import { useGetFeaturesQuery } from '../api/features/getFeatures';
import { useMemo } from 'react';
import { useWelcomeQuery } from '../api/getWelcomeDetails';

const useGetFeatureFlags = () => {
  const { data: welcomeData } = useWelcomeQuery();
  const { data: featuresData, isLoading } = useGetFeaturesQuery(!!welcomeData);

  const mprFlags = useMemo(
    () => ({
      enablePayNow: featuresData?.enablePayNow ?? false,
      enablePBEEsign: featuresData?.enablePBEEsign ?? false,
      enableServiceText: featuresData?.enableServiceText ?? false,
      disableChat: featuresData?.disableChat ?? false,
      enableSettings: featuresData?.enableSettings ?? false,
      enableContactUsTextSection:
        featuresData?.enableContactUsTextSection ?? false,
    }),
    [featuresData]
  );

  return {
    ...mprFlags,
    isLoading,
  };
};

export default useGetFeatureFlags;
